import { useEffect } from 'react';
import { useEventCallback } from '@mui/material/utils';
import type { FormDefinition } from '../format/form-definition';
import type { BuilderDispatch, BuilderState } from './state';

const SAVING_AT_LEAST_MS = 400;

// ToDo: for now, check and update according to upcoming be
export const save = async (
  state: BuilderState,
  dispatch: BuilderDispatch,
  onSave: (definition: FormDefinition) => Promise<void>,
): Promise<void> => {
  if (state.saving || !(state.saved === null || state.unsaved || state.failed)) return;
  const definition = state.form;
  dispatch({ type: 'saveStarted' });
  const atLeast = new Promise(resolve => window.setTimeout(resolve, SAVING_AT_LEAST_MS));
  const [saved] = await Promise.allSettled([Promise.resolve().then(() => onSave(definition)), atLeast]);
  if (saved.status === 'fulfilled') dispatch({ type: 'saveSucceeded', definition });
  else {
    dispatch({ type: 'saveFailed' });
  }
};

export const useUnsavedReport = (unsaved: boolean, onUnsavedChange: ((unsaved: boolean) => void) | undefined): void => {
  const report = useEventCallback((now: boolean) => onUnsavedChange?.(now));
  useEffect(() => {
    report(unsaved);
  }, [unsaved, report]);
};
